import useRequest from '@/websdk/utils/request';

export default (function () {
  const { exec, isRequestSuccessed } = useRequest({
    url: '/api/production-plans',
    name: 'PUT_PRODUCTION_PLAN',
    method: 'PUT',
  });

  return [exec, isRequestSuccessed];
});
